export default __webpack_public_path__ + "static/media/zenodo-select-upload.15ec8ee3.png";